import { render, staticRenderFns } from "./integralDetail.vue?vue&type=template&id=20684324&scoped=true&"
import script from "./integralDetail.vue?vue&type=script&lang=js&"
export * from "./integralDetail.vue?vue&type=script&lang=js&"
import style0 from "./integralDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./integralDetail.vue?vue&type=style&index=1&id=20684324&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20684324",
  null
  
)

export default component.exports